import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import useTopPanel from 'hooks/useTopPanel';
import ReminderAddModal from './AddModal';
import BaseTable from 'components/ui/tables/BaseTable';
import SimpleSearchInput from 'components/SearchInputNavbar';

const Reminder = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const [refetch, setRefetch] = useState(false);
  const [openReminderModal, setOpenReminderModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('settings.reminders.title')}</div>
    );
  }, [i18n.language]);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center gap-8'>
          <div className='header-actions filter-box flex items-center w-full'>
            {/* <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
            >
              {t('common.button.filter')}
            </Button> */}
            <SimpleSearchInput inputKey='name' />
          </div>
          <div className='header-actions action-buttons-box py-3 flex items-center justify-center gap-2'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='success'
              onClick={() => setOpenReminderModal(true)}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='jobss/jobs'
          emitTableColumns={{ open, setOpen }}
          tableName='jobss/jobs'
          headCells={[
            { code: 'id', label: '#' },
            { code: 'name', label: t('common.fields.type') },
            { code: 'after_hour', label: t('common.fields.afterHours') },
            { code: 'after_minute', label: t('common.fields.afterMinutes') },
            { code: 'created_at', label: t('crm.filter.created') },
            { code: 'updated_at', label: t('crm.filter.lastChange') },
          ]}
          columns={[
            { code: 'id' },
            { code: 'name' },
            { code: 'after_hour' },
            { code: 'after_minute' },
            { code: 'created_at', type: 'dateTime' },
            { code: 'updated_at', type: 'dateTime' },
          ]}
          actionModal={{
            setOpen: setOpenReminderModal,
            setData: setItem,
            btnColor: 'warning',
            icon: 'bi bi-pencil-square',
          }}
          actionDelete={{
            link: 'jobs/delete',
            method: 'post',
            paramId: true,
            key: 'id',
          }}
        />
      </div>

      {openReminderModal && (
        <ReminderAddModal
          open={openReminderModal}
          item={item}
          setItem={setItem}
          setOpen={setOpenReminderModal}
          setRefetch={setRefetch}
        />
      )}
    </div>
  );
};

export default memo(Reminder);
